<template>
  <div>
    <apexchart
      width="100%"
      :type="type"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
export default {
  name: "ChartBar",
  props: {
    type: {
      type: String,
      default: "bar",
    },
    series: {
      type: Array,
      require: true,
    },
  },
  data: function () {
    return {
      options: {
        chart: {
          height: 50,
          width: "100%",
          type: "bar",
          dropShadow: {
            enabled: true,
            top: 1,
            left: 1,
            blur: 2,
            color: "#acb0c3",
            opacity: 0.7,
          },
        },
        colors: ["#5c1ac3", "#ffbb44"],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "40%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            shadeIntensity: 0.3,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 0.8,
            stops: [0, 100],
          },
        },
        xaxis: {
          categories: [
            "Ene",
            "Feb",
            "Mar",
            "Abr",
            "May",
            "Jun",
            "Jul",
            "Ago",
            "Sep",
            "Oct",
            "Nov",
            "Dic",
          ],
        },
      },
    };
  },
};
</script>
